import React from 'react';
import { AccessTime, Done, DoneAll, Schedule, Error } from '@material-ui/icons';
import { observer } from 'mobx-react-lite';

export default observer(function StatusIcon({ status, isOptimistic }) {
  const iconStyle = { fontSize: 14 };

  if (isOptimistic) {
    return <Schedule style={{ ...iconStyle, color: '#999', opacity: 0.7 }} />;
  }

  // Enum mapping
  const map = {
    '0': 0, 'error': 0, 'failed': 0, 'fail': 0,
    '1': 1, 'pending': 1, 'sending': 1,
    '2': 2, 'sent': 2, 'server_ack': 2, 'serverack': 2,
    '3': 3, 'delivered': 3, 'delivery_ack': 3, 'deliveryack': 3, 'receive': 3, 'received': 3,
    '4': 4, 'read': 4, 'seen': 4, 'viewed': 4,
    '5': 5, 'played': 5
  };

  let statusMessage;
  if (typeof status === 'number') {
    statusMessage = status;
  } else if (typeof status === 'string') {
    const trimmed = status.trim().toLowerCase();
    if (/^\d+$/.test(trimmed)) {
      statusMessage = Number(trimmed);
    } else {
      statusMessage = map[trimmed];
      if (statusMessage === undefined) {
        statusMessage = 2;
      }
    }
  } else {
    statusMessage = 2; // Default to SERVER_ACK
  }

  switch (statusMessage) {
    case 0: // ERROR
      return <Error style={{ ...iconStyle, color: '#f44336' }} />;
    case 1: // PENDING
      return <AccessTime style={{ ...iconStyle, color: '#999', opacity: 0.6 }} />;
    case 2: // SERVER_ACK
      return <Done style={{ ...iconStyle, color: '#999' }} />;
    case 3: // DELIVERY_ACK
      return <DoneAll style={{ ...iconStyle, color: '#999' }} />;
    case 4: // READ
      return <DoneAll style={{ ...iconStyle, color: '#53BDEB' }} />;
    case 5: // PLAYED
      return <DoneAll style={{ ...iconStyle, color: '#53BDEB', fontWeight: 'bold' }} />;
    default:
      return <Done style={{ ...iconStyle, color: '#ccc', opacity: 0.7 }} />;
  }
});